<div class="" style="overflow: hidden;">
    <mat-dialog-content class="" style="overflow: hidden;">
        <div class="edit-num">{{ data?.message }}
            <!-- <span><button class="closeButton" (click)="closeDialogue()">X</button></span> -->
        </div>
        <form [formGroup]="phoneForm">
            <!-- <label class="phn-label">Phone Number</label> -->
            <!-- <div class="form-group assessment_pb-10 signup-form-input-mobile">
                <img class="signup-form-input-icon" src="assets/img/phone-icon.svg" alt="" />
                <input class="form-control signup-form-input-field" type="text" formControlName="phone" placeholder="New Number" maxlength="10" phone-number>
            </div> -->
            <div class="form-group 111 text-center">
                <!-- <img class="signup-form-input-icon" src="assets/img/phone-icon.svg" alt="" /> -->
                <ngx-intl-tel-input [cssClass]="'intelTel font-w6 form-control-mob form-control.tel'"
                    [preferredCountries]="[CountryISO.India]" [enableAutoCountrySelect]="false"
                    [enablePlaceholder]="false" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" maxLength="10"
                    [phoneValidation]="true" [separateDialCode]="true" name="phone" formControlName="phone"
                    (keypress)="enterKey($event)" readonly></ngx-intl-tel-input><!-- (keyup)="doSearch($event)" -->
                    <span class="assessment_pt-10 error-msg" *ngIf="errorMessage">
                        {{errorMessage}}
                    </span>
                </div>
            
            <button class="btn btn-primary btn-block" type="button" (click)="verifyAndUpdate()">VERIFY AND
                UPDATE</button>
            <div class="">
                <button class="assessment_pt-20 btn-block btn-link" type="button" (click)="cancel()">CANCEL</button>
            </div>
        </form>
    </mat-dialog-content>

</div>